import { css } from 'aphrodite';
import * as React from 'react';
import { brandPrimary } from '../../styles/colors';
import { SvgIcon } from '../svgs/icons/SvgIcon';
import { styleSheet } from './styles';

interface IProps extends React.AllHTMLAttributes<HTMLInputElement> {
	checkedFillColor?: string;
	checkedStrokeColor?: string;
	className?: string;
	iconClassName?: string;
	id?: string;
	inputClassName?: string;
	labelClassName?: string;
	type?: 'small' | 'large';
	uncheckedStrokeColor?: string;
	'data-testid'?: string;
}

/**
 * @deprecated Use `RadioGroup` / `RadioGroupItem` from `components-v2/RadioGroup` in new code. This control
 * predates components-v2: it has no group context, so arrow-key navigation and single-selection enforcement
 * are left to each caller.
 */
export const RadioButton: React.FC<IProps> = props => {
	const {
		children,
		className,
		iconClassName = '',
		id,
		inputClassName,
		labelClassName = '',
		type,
		uncheckedStrokeColor,
		checkedFillColor,
		checkedStrokeColor,
		'data-testid': dataTestId,
		...restProps
	} = props;
	const size = type === 'large' ? 20 : 12;
	return (
		<label htmlFor={id} className={`radio-button ${css(styleSheet.radioButton)} ${className || ''}`}>
			<input
				{...restProps}
				className={`${css(styleSheet.input)} ${inputClassName || ''}`}
				id={id}
				type='radio'
				data-testid={dataTestId}
			/>
			<SvgIcon className={`${css(styleSheet.icon)} ${iconClassName}`} height={size} width={size}>
				<g fill='none'>
					{!!props.checked && <circle cx='6' cy='6' r='4' fill={checkedFillColor || brandPrimary} />}
					<circle
						cx='6'
						cy='6'
						r='5.5'
						stroke={props.checked ? checkedStrokeColor || brandPrimary : uncheckedStrokeColor || '#666666'}
						strokeWidth={1}
					/>
				</g>
			</SvgIcon>
			{!!children && <div className={`${css(styleSheet.label)} ${labelClassName}`}>{children}</div>}
		</label>
	);
};
